import CreateProject from "./CreateProject/CreateProject"
import ProjectInwardList from "./ProjectInwardList/ProjectInwardList"
export { CreateProject, ProjectInwardList }